import { StyledRegisterHeader } from "./styled";
import logo from "../../assets/icons/Logo.svg"
import { StyledBtn } from "../../styles/Buttons"
import { useNavigate } from "react-router-dom";

const RegisterHeader = ()=>{

    const navigate = useNavigate();

    const goBack = ()=>{
        navigate(-1)
    }

    return(
        <StyledRegisterHeader>
            <img src={logo} alt="Kenzi Hub" />

            <StyledBtn onClick={goBack} BGcolor="var(--color-grey-3)" fontSize="0.75rem" >Voltar</StyledBtn>
        </StyledRegisterHeader>
    )

}

export default RegisterHeader